import angular from 'angular';
import CartService from './cart-service';
import OrderService from './order-service';
import PaymentService from './payment-service';
import GoogleAnalyticsService from './google-analytics-service';
import LocationService from './location-service';
import StoreFinderService from './store-finder-service';
import ScrollToService from './scroll-to-service';
import SiteLinksService from './site-links-service';
import ParameterService from './parameter-service';
import AccountService from './account-service';

let serviceModule = angular.module('app.services', [])
    .service('orderService', OrderService)
    .service('paymentService', PaymentService)
    .service('cartService', CartService)
    .service('googleAnalyticsService', GoogleAnalyticsService)
    .service('locationService', LocationService)
    .service('storeFinderService', StoreFinderService)
    .service('scrollToService', ScrollToService)
    .service('siteLinksService', SiteLinksService)
    .service('parameterService', ParameterService)
    .service('accountService', AccountService);

export default serviceModule;


// WEBPACK FOOTER //
// ./src/app/services/services.js